<template>
  <q-card flat :style="$q.screen.lt.md?'':'width: 500px; max-width: 80vw;'">
    <q-card-section class="no-padding">
      <q-banner class="bg-primary text-white" inline-actions>
        حواله ({{items[0].GoEvent_Num}})
        <template v-slot:action>
          <q-btn round flat icon="close" v-close-popup />
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section v-for="(item, index) in items" :key="index">
      <q-banner>
        <q-badge :label="index+1" color="brown" text-color="white" />
        {{item.Goods_Name}}
        <q-badge color="red" text-color="white" :label="`${item.GoEvent_StOut} عدد`" align="top"/>
      </q-banner>
      <q-chip square icon="store" :label="item.StorName"/>
      <q-chip square icon="support_agent" :label="item.UserName" v-if="item.UserName">
        <q-badge style="direction: ltr" color="teal" text-color="white" :label="item.Confirm_User_Date | toJalaliDateTime" />
      </q-chip>
    </q-card-section>
  </q-card>
</template>

<script>
export default {
  name: "OrderStoreList",
  props:{
    items:{
      type:Object,
      required: true,
      default:()=>[]
    }
  }
}
</script>

<style scoped>

</style>